import { ThemeUICSSObject } from '@apia/theme';
import menu from './menu';
/* IMPORT HERE */

const mainApp: ThemeUICSSObject = {
  menu,
  /* PREPEND HERE */
};

export default mainApp;
